import api from "./api";

const RESOURCE = "/api/motivos-rejeicao";

const MotivoRejeicao = {
  findById: (id) => api.get(RESOURCE + `/${id}`),
  listData: (search) => api.get(`${RESOURCE}?search=${search || ""}`),
  listFullData: (active, search) =>
    api.get(
      `${RESOURCE}/completo?active=${active !== undefined ?? ""}&search=${
        search || ""
      }`
    ),
  sendData: (data) => api.post(RESOURCE, { ...data }),
};

export default MotivoRejeicao;
